import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ErrorService } from '../../shared/services/error-service';
import { ToastService } from '../../shared/toast/toast.service';
import { ReportConstants } from '../../shared/constants/report.constants';
import { TabControlComponent } from '../../shared/controls/tab-control/tab-control.component';
import { TabPageComponent } from '../../shared/controls/tab-control/tab-page.component';

@Component({
    selector: 'user-report',
    templateUrl: './user-report.component.html',
    styleUrls: ['./user-report.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
        TabControlComponent,
        TabPageComponent
    ],

    providers: [
    ]
})
export class UserReportComponent implements OnInit {

    constructor(
        private router: Router,
        private errorService: ErrorService,
        private toastService: ToastService,
    ) {}

    ngOnInit(): void {
    }

    onRunReport(): void {
        try {
            this.router.navigate(['/report-viewer', ReportConstants.UserReport]);
        }
        catch (error) {
            this.toastService.show('Error running the report', 'error');
            this.errorService.handleError(error);
        }
    }
}